import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Checkbox from "rc-checkbox";
import axios from "axios";

import CanvasActions from "../../actions/CanvasActions.js";

import loader from "../../assets/loader.gif";

import "./style.css";
import Axios from "axios";

class EmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      sent: false
    };
  }

  submit() {
    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    if (!validateEmail(this.state.email)) {
      alert("please enter a valid email address");
      return;
    }

    axios
      .post(
        `https://5vjk67b3e1.execute-api.us-east-1.amazonaws.com/production/email`,
        {
          address: this.state.email,
          file: this.props.canvas.file
        }
      )
      .then(result => {
        this.setState({ sent: true });
      });
  }
  render() {
    return (
      <div className="email-modal">
        <div className="email-modal-inner">
          <h1>
            <i className="fa fa-check-circle" />
            Great Success!
          </h1>
          <p>Please wait while we add your artwork to cart.</p>

          <img src={loader} alt="" />
          {/* {this.props.canvas.cartLoading ? (
            <img src={loader} alt="" />
          ) : (
            <div>
              <div
                className="btn"
                onClick={() => {
                  this.props.checkout(2);
                }}
              >
                <span>Add 2nd Poster, get 25% Off</span>
              </div>
              <div
                className="checkout"
                onClick={() => {
                  this.props.checkout(1);
                }}
              >
                <i className="fa fa-credit-card" />
                <span>Proceed to Cart</span>
              </div>
              {this.state.sent ? (
                <div className="email">
                  <p>Print saved</p>
                </div>
              ) : (
                <div className="email">
                  <p>Submit your email address to save your print.</p>
                  <div className="input">
                    <input
                      type="text"
                      value={this.state.email}
                      onChange={e => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                    <div className="btn" onClick={this.submit.bind(this)}>
                      <span>Save</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )} */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas,
    theme: state.canvas.theme
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailModal);

export default App;



// WEBPACK FOOTER //
// ./src/components/EmailModal/index.js